<sg-basic-app-init-and-templates></sg-basic-app-init-and-templates>
@if (!appConfig.branding.hideTopBar) {
  <sg-top-nav
    [hideActionsMenu]="appConfig.branding.hideActionsMenu"
    [showBurgerMenu]="!appConfig.branding.hideSideNav && appConfig.branding.showBurgerMenu"
    showLogoAt="gt-xs"
    [logoSrc]="logoSrc"
    (logoutClick)="logout()"
    (langClick)="changeLang($event)"
    (menuButtonClick)="toggleSideNav()"
    [isSticky]="appConfig.branding.stickyTopNav"
    [ngClass]="{ 'top-nav-admin-prod-color': env.isAdminProd }"></sg-top-nav>
}
@if (backgroundImgSrc) {
  <img class="sg-pos-abs" style="height: 100%; width: 100%; overflow: hidden; z-index: -1" [src]="backgroundImgSrc" />
}
@if (!appConfig.branding.hideSideNav) {
  <sg-sidenav
    [expenderEnabled]="appConfig.branding.showSideBarExpender"
    [backgroundImageSrc]="sidenavBackgroundImgSrc"
    [showMobileBurger]="!!(isOnChatRoute$ | async)"
    [closeOnMobileInit]="!!(isOnChatRoute$ | async)"
    [mobileMode]="(isOnChatRoute$ | async) ? 'over' : 'push'"
    [mobileBreakpointPx]="(isOnChatRoute$ | async) ? 767 : 599"
    #sgSidenav
    class="sg-flex-auto">
    <div class="sg-main-view {{ activeRouteComponents | async }}"><router-outlet class="main-router-outlet"></router-outlet></div>
  </sg-sidenav>
}
@if (appConfig.branding.hideSideNav) {
  <div class="sg-flex-auto">
    <div class="sg-main-view" style="padding: 0"><router-outlet class="main-router-outlet"></router-outlet></div>
  </div>
}
<sg-build-watermark></sg-build-watermark>
